var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10.634,
    r: 9.5,
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1246 12.414C13.1246 13.578 12.2486 14.586 10.3406 14.694V16.074H9.74059V14.706C8.56459 14.646 7.46059 14.214 6.87259 13.614L7.22059 12.93C7.77259 13.47 8.73259 13.878 9.74059 13.938V10.782C8.42059 10.458 7.07659 10.05 7.07659 8.46603C7.07659 7.31403 7.90459 6.31803 9.74059 6.17403V4.79403H10.3406V6.16203C11.2406 6.19803 12.1406 6.46203 12.7766 6.90603L12.4766 7.61403C11.8046 7.18203 11.0366 6.95403 10.3406 6.91803V10.098C11.6966 10.422 13.1246 10.806 13.1246 12.414ZM7.95259 8.44203C7.95259 9.35403 8.75659 9.69003 9.74059 9.94203V6.94203C8.50459 7.05003 7.95259 7.68603 7.95259 8.44203ZM10.3406 13.938C11.6606 13.842 12.2486 13.23 12.2486 12.462C12.2486 11.514 11.3726 11.19 10.3406 10.938V13.938Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarIcon);
export default __webpack_public_path__ + "static/media/DollarIcon.d563229f2ca9b934a3c925ba2a90cf97.svg";
export { ForwardRef as ReactComponent };